import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function TermsModal({
  isOpen,
  onClose
}: TermsModalProps) {
  // Close on ESC key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-326">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50" onClick={onClose} data-id="element-327" />

          {/* Modal */}
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-328">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: [0.16, 1, 0.3, 1]
        }} className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[85vh] flex flex-col" onClick={e => e.stopPropagation()} data-id="element-329">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-gray-200" data-id="element-330">
                <h2 className="text-2xl font-bold text-[#2C3E50]" data-id="element-331">
                  Términos y Condiciones de Uso
                </h2>
                <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" aria-label="Cerrar" data-id="element-332">
                  <X className="w-5 h-5 text-gray-500" data-id="element-333" />
                </button>
              </div>

              {/* Content */}
              <div className="overflow-y-auto p-6 space-y-6 text-[#2C3E50]" data-id="element-334">
                <div className="bg-[#E8F4F8] border-l-4 border-[#5B9BD5] p-4 rounded" data-id="element-335">
                  <p className="font-semibold text-lg" data-id="element-336">
                    Tarjeta EMPRENDE FULLPASS
                  </p>
                </div>

                <section data-id="element-337">
                  <h3 className="text-lg font-semibold mb-3 text-[#5B9BD5]" data-id="element-338">
                    1. NATURALEZA DEL PROGRAMA
                  </h3>
                  <p className="text-gray-700 leading-relaxed" data-id="element-339">
                    El presente documento establece los términos y condiciones
                    aplicables al uso de la tarjeta de fidelización gratuita
                    denominada EMPRENDE FULLPASS (en adelante, "la Tarjeta"), la
                    cual permite a sus titulares acceder a beneficios,
                    descuentos y promociones ofrecidos por comercios afiliados
                    al programa.
                  </p>
                </section>

                <section data-id="element-340">
                  <h3 className="text-lg font-semibold mb-3 text-[#5B9BD5]" data-id="element-341">
                    2. ACCESO A LA TARJETA
                  </h3>
                  <ul className="space-y-2 text-gray-700 leading-relaxed" data-id="element-342">
                    <li className="flex gap-2" data-id="element-343">
                      <span className="text-[#5B9BD5] font-bold" data-id="element-344">•</span>
                      <span data-id="element-345">
                        La Tarjeta es gratuita y de uso personal e
                        intransferible.
                      </span>
                    </li>
                    <li className="flex gap-2" data-id="element-346">
                      <span className="text-[#5B9BD5] font-bold" data-id="element-347">•</span>
                      <span data-id="element-348">
                        Podrá acceder a ella cualquier persona natural mayor de
                        edad que complete el formulario de afiliación
                        correspondiente.
                      </span>
                    </li>
                    <li className="flex gap-2" data-id="element-349">
                      <span className="text-[#5B9BD5] font-bold" data-id="element-350">•</span>
                      <span data-id="element-351">
                        El uso de la Tarjeta implica la aceptación plena de
                        estos términos y condiciones.
                      </span>
                    </li>
                  </ul>
                </section>

                <section data-id="element-352">
                  <h3 className="text-lg font-semibold mb-3 text-[#5B9BD5]" data-id="element-353">
                    3. BENEFICIOS Y PROMOCIONES
                  </h3>
                  <ul className="space-y-2 text-gray-700 leading-relaxed" data-id="element-354">
                    <li className="flex gap-2" data-id="element-355">
                      <span className="text-[#5B9BD5] font-bold" data-id="element-356">•</span>
                      <span data-id="element-357">
                        Los beneficios ofrecidos pueden incluir: descuentos
                        directos, promociones especiales, servicios
                        preferenciales, obsequios u otros incentivos, según lo
                        determine cada comercio afiliado.
                      </span>
                    </li>
                    <li className="flex gap-2" data-id="element-358">
                      <span className="text-[#5B9BD5] font-bold" data-id="element-359">•</span>
                      <span data-id="element-360">
                        Cada comercio es el único responsable de aplicar,
                        mantener, modificar o cancelar los beneficios que ofrece
                        a los usuarios de la Tarjeta.
                      </span>
                    </li>
                    <li className="flex gap-2" data-id="element-361">
                      <span className="text-[#5B9BD5] font-bold" data-id="element-362">•</span>
                      <span data-id="element-363">
                        Los beneficios están sujetos a condiciones particulares
                        propias de cada comercio (vigencia, stock, montos
                        mínimos de compra, restricciones, etc.).
                      </span>
                    </li>
                  </ul>
                </section>

                <section data-id="element-364">
                  <h3 className="text-lg font-semibold mb-3 text-[#5B9BD5]" data-id="element-365">
                    4. RESPONSABILIDAD DEL PROGRAMA
                  </h3>
                  <ul className="space-y-2 text-gray-700 leading-relaxed" data-id="element-366">
                    <li className="flex gap-2" data-id="element-367">
                      <span className="text-[#5B9BD5] font-bold" data-id="element-368">•</span>
                      <span data-id="element-369">
                        TicketMaestro y su Plataforma Benefica en su rol de
                        procesador de La Tarjeta, y la Cámara Ecuatoriana de
                        Desarrollo Sostenible (CEDES), actúan únicamente como
                        intermediarios que conectan a los usuarios con comercios
                        aliados, sin asumir responsabilidad por la calidad,
                        disponibilidad o condiciones de los productos o
                        servicios ofrecidos.
                      </span>
                    </li>
                    <li className="flex gap-2" data-id="element-370">
                      <span className="text-[#5B9BD5] font-bold" data-id="element-371">•</span>
                      <span data-id="element-372">
                        En caso de cualquier inconveniente o reclamo relacionado
                        con los beneficios, el usuario deberá comunicarse
                        directamente con el comercio correspondiente.
                      </span>
                    </li>
                  </ul>
                </section>

                <section data-id="element-373">
                  <h3 className="text-lg font-semibold mb-3 text-[#5B9BD5]" data-id="element-374">
                    5. VIGENCIA Y MODIFICACIONES
                  </h3>
                  <ul className="space-y-2 text-gray-700 leading-relaxed" data-id="element-375">
                    <li className="flex gap-2" data-id="element-376">
                      <span className="text-[#5B9BD5] font-bold" data-id="element-377">•</span>
                      <span data-id="element-378">
                        La vigencia de la Tarjeta es indefinida, salvo que el
                        usuario o la organización emiten renuncien expresamente
                        a su uso.
                      </span>
                    </li>
                    <li className="flex gap-2" data-id="element-379">
                      <span className="text-[#5B9BD5] font-bold" data-id="element-380">•</span>
                      <span data-id="element-381">
                        La organización se reserva el derecho de modificar,
                        suspender o cancelar el programa o sus términos y
                        condiciones, informando oportunamente a los usuarios a
                        través de sus canales oficiales.
                      </span>
                    </li>
                  </ul>
                </section>

                <section data-id="element-382">
                  <h3 className="text-lg font-semibold mb-3 text-[#5B9BD5]" data-id="element-383">
                    6. PROTECCIÓN DE DATOS PERSONALES
                  </h3>
                  <ul className="space-y-2 text-gray-700 leading-relaxed" data-id="element-384">
                    <li className="flex gap-2" data-id="element-385">
                      <span className="text-[#5B9BD5] font-bold" data-id="element-386">•</span>
                      <span data-id="element-387">
                        Al afiliarse, el usuario autoriza el tratamiento de sus
                        datos personales conforme a la legislación vigente,
                        exclusivamente para fines informativos y promocionales
                        relacionados con el programa.
                      </span>
                    </li>
                    <li className="flex gap-2" data-id="element-388">
                      <span className="text-[#5B9BD5] font-bold" data-id="element-389">•</span>
                      <span data-id="element-390">
                        Los datos no serán compartidos con terceros sin
                        consentimiento del titular, salvo requerimiento legal.
                        Puede ver más detalles en el documento de nuestras
                        Políticas de Privacidad y Protección de Datos
                        Personales.
                      </span>
                    </li>
                  </ul>
                </section>

                <section data-id="element-391">
                  <h3 className="text-lg font-semibold mb-3 text-[#5B9BD5]" data-id="element-392">
                    7. USO INDEBIDO Y CANCELACIÓN
                  </h3>
                  <ul className="space-y-2 text-gray-700 leading-relaxed" data-id="element-393">
                    <li className="flex gap-2" data-id="element-394">
                      <span className="text-[#5B9BD5] font-bold" data-id="element-395">•</span>
                      <span data-id="element-396">
                        El uso fraudulento, indebido o contrario a estos
                        términos puede dar lugar a la anulación inmediata de la
                        Tarjeta y la pérdida de sus beneficios.
                      </span>
                    </li>
                    <li className="flex gap-2" data-id="element-397">
                      <span className="text-[#5B9BD5] font-bold" data-id="element-398">•</span>
                      <span data-id="element-399">
                        La organización podrá retirar o suspender la tarjeta en
                        caso de mal uso sin necesidad de notificación previa.
                      </span>
                    </li>
                  </ul>
                </section>

                <section data-id="element-400">
                  <h3 className="text-lg font-semibold mb-3 text-[#5B9BD5]" data-id="element-401">
                    8. VIGENCIA
                  </h3>
                  <p className="text-gray-700 leading-relaxed" data-id="element-402">
                    La vigencia de estos Términos y Condiciones de Uso es desde
                    el 12 de septiembre de 2025 y permanecerá vigente hasta que
                    exista una nueva versión que la reemplace.
                  </p>
                </section>
              </div>

              {/* Footer */}
              <div className="p-6 border-t border-gray-200" data-id="element-403">
                <button onClick={onClose} className="w-full bg-[#5B9BD5] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#4A8AC4] transition-colors" data-id="element-404">
                  Cerrar
                </button>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}